<template>
  <div class="knowledge-detail-page">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item @click="goBack" style="cursor: pointer; color: #3b82f6;">
          <el-icon><ArrowLeft /></el-icon>
          知识库管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ knowledgeBaseName }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="page-header">
      <div class="header-content">
        <div class="title-section">
          <h1>{{ knowledgeBaseName }}</h1>
          <p>{{ knowledgeBaseDescription }}</p>
        </div>
        <div class="header-actions">
          
        </div>
      </div>
    </div>

    <!-- 操作栏 -->
    <div class="action-bar">
      <div class="search-section">
        <el-input
          v-model="searchQuery"
          placeholder="请输入文件名称"
          prefix-icon="Search"
          clearable
          style="width: 300px"
        />
        <el-button type="text">搜索</el-button>
      </div>

      <el-button type="primary" @click="addKnowledge">
            <el-icon><Plus /></el-icon>
            添加新文件
          </el-button>
    </div>

    <!-- 文档列表 -->
    <div class="document-list">
      <el-table :data="filteredDocumentList" style="width: 100%" v-loading="loading">
        <el-table-column width="60">
          <template #header>
            <el-checkbox v-model="selectAll" @change="handleSelectAll" />
          </template>
          <template #default="scope">
            <el-checkbox v-model="scope.row.selected" @change="handleSelectChange" />
          </template>
        </el-table-column>
        <el-table-column label="#" width="60">
          <template #default="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="名称↓" min-width="300">
          <template #default="scope">
            <div class="document-name">
              <el-icon class="file-icon" :class="getFileIconClass(scope.row.fileType)">
                <Document v-if="scope.row.fileType === 'PDF'" />
                <Document v-else-if="scope.row.fileType === 'Word'" />
                <Document v-else-if="scope.row.fileType === 'Excel'" />
                <Document v-else />
              </el-icon>
              <span>{{ scope.row.name }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="segmentationMode" label="分段模式" width="120">
          <template #default="scope">
            <div class="segmentation-mode">
              <span>通用</span>
              <el-icon class="gear-icon"><Setting /></el-icon>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="characterCount" label="字符数↓" width="100">
          <template #default="scope">
            {{ formatCharacterCount(scope.row.wordCount) }}
          </template>
        </el-table-column>
        <el-table-column prop="hitCount" label="召回次数↓" width="100">
          <template #default="scope">
            {{ scope.row.hitCount }}
          </template>
        </el-table-column>
        <el-table-column prop="uploadTime" label="上传时间↓" width="180">
          <template #default="scope">
            {{ scope.row.uploadTime }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template #default="scope">
            <div class="status-indicator">
              <span class="status-dot" :class="{ 'available': scope.row.enabled }"></span>
              <span>{{ scope.row.enabled ? '可用' : '不可用' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template #default="scope">
            <!-- <el-switch 
              v-model="scope.row.enabled" 
              @change="toggleDocumentStatus(scope.row)"
              size="small"
            /> -->

            <el-button type="text" @click="downloadDocument(scope.row)" class="action-btn">
              <el-icon><Download /></el-icon>
            </el-button>
            <el-button type="text" @click="deleteDocument(scope.row)" class="action-btn delete-btn" v-if="isAdmin" >
              <el-icon><Delete /></el-icon>
            </el-button>
            <!-- <el-button type="text" @click="showDocumentMenu(scope.row)" class="action-btn">
              <el-icon><MoreFilled /></el-icon>
            </el-button> -->
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-wrapper">
        <el-pagination
          v-model:current-page="currentPage"
          v-model:page-size="pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <!-- 新增/编辑文档对话框 -->
    <el-dialog
      v-model="knowledgeDialogVisible"
      :title="isEdit ? '编辑文档' : '添加文档'"
      width="50%"
    >
      <el-form :model="knowledgeForm" label-width="100px" ref="formRef">
        <el-form-item label="文档名称">
          <el-input v-model="knowledgeForm.title" placeholder="请输入文档名称" />
        </el-form-item>
        <el-form-item label="选择文件" required>
          <el-upload
            ref="uploadRef"
            :auto-upload="false"
            :on-change="handleFileChange"
            :before-upload="beforeUpload"
            :show-file-list="true"
            :limit="1"
            accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.md"
          >
            <el-button type="primary">
              <el-icon><Upload /></el-icon>
              选择文件
            </el-button>
            <template #tip>
              <div class="el-upload__tip">
                支持 PDF、Word、Excel、PowerPoint、Text、Markdown 格式，文件大小不超过 100MB
              </div>
            </template>
          </el-upload>
        </el-form-item>
        <el-form-item label="文档描述">
          <el-input
            v-model="knowledgeForm.content"
            type="textarea"
            :rows="4"
            placeholder="请输入文档描述（可选）"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="knowledgeDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="saveKnowledge" :loading="uploading">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useRouter, useRoute } from 'vue-router'
import { ArrowLeft, Document, Setting, Download, MoreFilled, Delete, Upload } from '@element-plus/icons-vue'
import { agentAPI,approvalAPI } from '../api/index.js'

const router = useRouter()
const route = useRoute()

const searchQuery = ref('')
const currentPage = ref(1)
const pageSize = ref(10)
const total = ref(0)
const knowledgeDialogVisible = ref(false)
const isEdit = ref(false)
const selectAll = ref(false)
const uploading = ref(false)
const uploadRef = ref()
const formRef = ref()

const knowledgeBaseName = ref('')
const knowledgeBaseDescription = ref('')

const knowledgeForm = reactive({
  title: '',
  content: '',
  file: null
})

const documentList = ref([])
const loading = ref(false)

const isAdmin = ref(localStorage.getItem('roles') === 'admin')

// 文件选择处理
const handleFileChange = (file) => {
  knowledgeForm.file = file.raw
  knowledgeForm.title = file.name.split('.')[0] // 使用文件名作为标题
}

// 文件上传前验证
const beforeUpload = (file) => {
  const allowedTypes = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'text/plain',
    'text/markdown'
  ]
  
  const isValidType = allowedTypes.includes(file.type)
  if (!isValidType) {
    ElMessage.error('不支持的文件格式！')
    return false
  }
  
  const isLt100M = file.size / 1024 / 1024 < 100
  if (!isLt100M) {
    ElMessage.error('文件大小不能超过 100MB！')
    return false
  }
  
  return false // 阻止自动上传
}

// 获取知识库详情和文件列表
const fetchKnowledgeBaseDetail = async () => {
  loading.value = true
  try {
    // 获取知识库基本信息
    const kbId = route.params.id
    const kbName = route.query.name
    
    knowledgeBaseName.value = kbName || '知识库详情'
    knowledgeBaseDescription.value = '知识库描述信息'
    
    // 获取文件列表
    const response = await agentAPI.getDocumentList({
      dataset_id: kbId,
      page: currentPage.value,
      limit: pageSize.value
    })
    
    if (response && response.code === 0) {
      // 解析嵌套的 JSON 字符串
      let dataArray = []
      if (typeof response.data === 'string') {
        const parsedData = JSON.parse(response.data)
        console.log("文档列表数据:", parsedData)
        dataArray = parsedData.data || []
      } else if (response.data && response.data.data) {
        dataArray = response.data.data
      } else if (Array.isArray(response.data)) {
        dataArray = response.data
      }
      
      // 将接口返回的数据转换为组件需要的格式
      documentList.value = dataArray.map((item, index) => ({
        id: item.id || `doc-${index + 1}`,
        name: item.name || '未命名文档',
        fileType: getFileType(item.data_source_detail_dict?.upload_file?.extension),
        fileSize: formatFileSize(item.data_source_detail_dict?.upload_file?.size),
        wordCount: item.word_count || 0,
        hitCount: item.hit_count || 0,
        uploadTime: formatUploadTime(item.created_at),
        enabled: item.enabled,
        displayStatus: item.display_status || 'unknown',
        selected: false,
        // 额外信息
        position: item.position || 0,
        tokenCount: item.tokens || 0,
        indexingStatus: item.indexing_status
      }))
      
      // 更新分页信息
      if (typeof response.data === 'string') {
        const parsedData = JSON.parse(response.data)
        total.value = parsedData.total || 0
      } else if (response.data) {
        total.value = response.data.total || 0
      }
    } else {
      ElMessage.error('获取文档列表失败')
    }
  } catch (error) {
    console.error('获取知识库详情失败:', error)
    ElMessage.error('获取知识库详情失败')
  } finally {
    loading.value = false
  }
}

// 根据文件扩展名获取文件类型
const getFileType = (extension) => {
  if (!extension) return 'unknown'
  const ext = extension.toLowerCase()
  const typeMap = {
    'pdf': 'PDF',
    'doc': 'Word',
    'docx': 'Word',
    'xls': 'Excel',
    'xlsx': 'Excel',
    'ppt': 'PowerPoint',
    'pptx': 'PowerPoint',
    'txt': 'Text',
    'md': 'Markdown'
  }
  return typeMap[ext] || ext.toUpperCase()
}

// 格式化文件大小
const formatFileSize = (bytes) => {
  if (!bytes) return '0 B'
  const sizes = ['B', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(1024))
  return Math.round(bytes / Math.pow(1024, i) * 100) / 100 + ' ' + sizes[i]
}

// 格式化字符数（显示为k格式）
const formatCharacterCount = (count) => {
  if (!count) return '0'
  if (count < 1000) return count.toString()
  return (count / 1000).toFixed(1) + 'k'
}

// 格式化上传时间 - 转换为北京时间
const formatUploadTime = (timestamp) => {
  console.log(timestamp)
  if (!timestamp) {
    // 返回当前北京时间
    const now = new Date()
    const beijingTime = new Date(now.getTime() + 8 * 60 * 60 * 1000)
    return beijingTime.toISOString().slice(0, 16).replace('T', ' ')
  }
  
  // 创建日期对象并转换为北京时间
  const date = new Date(timestamp * 1000)
  const beijingTime = new Date(date.getTime() + 8 * 60 * 60 * 1000)
  
  // 格式化为 YYYY-MM-DD HH:mm 格式
  return beijingTime.toISOString().slice(0, 16).replace('T', ' ')
}

// 获取文件图标样式类
const getFileIconClass = (fileType) => {
  const classMap = {
    'PDF': 'pdf-icon',
    'Word': 'word-icon',
    'Excel': 'excel-icon',
    'PowerPoint': 'ppt-icon'
  }
  return classMap[fileType] || 'default-icon'
}

// 筛选后的文档列表
const filteredDocumentList = computed(() => {
  return documentList.value.filter(item => {
    const matchesSearch = !searchQuery.value || 
      item.name.toLowerCase().includes(searchQuery.value.toLowerCase())
    return matchesSearch
  })
})

// 全选处理
const handleSelectAll = (checked) => {
  documentList.value.forEach(item => {
    item.selected = checked
  })
}

const handleSelectChange = () => {
  const selectedCount = documentList.value.filter(item => item.selected).length
  selectAll.value = selectedCount === documentList.value.length
}

// 切换文档状态
const toggleDocumentStatus = (document) => {
  ElMessage.success(`文档已${document.enabled ? '启用' : '禁用'}`)
}

// 下载文档
const downloadDocument = async (doc) => {
  try {
    const kbId = route.params.id
    const response = await agentAPI.getFileDocument(kbId, doc.id)
    
    if (response && response.code === 0) {
      // 解析 data 字段中的 JSON 字符串
      const fileData = JSON.parse(response.data)
      console.log("文件数据:", fileData)
      
      if (fileData.download_url) {
        // 使用 fetch 获取文件内容
        const fileResponse = await fetch(fileData.download_url)
        
        if (!fileResponse.ok) {
          throw new Error(`HTTP error! status: ${fileResponse.status}`)
        }
        
        // 转换为 Blob
        const blob = await fileResponse.blob()
        
        // 创建 Blob URL
        const blobUrl = window.URL.createObjectURL(blob)
        
        // 创建下载链接
        const link = document.createElement('a')
        link.href = blobUrl
        link.download = fileData.name || doc.name
        link.style.display = 'none'
        
        // 添加到页面并触发下载
        document.body.appendChild(link)
        link.click()
        
        // 清理
        document.body.removeChild(link)
        window.URL.revokeObjectURL(blobUrl)
        
        ElMessage.success('开始下载')
      } else {
        ElMessage.error('获取下载链接失败')
      }
    } else {
      ElMessage.error('下载失败')
    }
  } catch (error) {
    console.error('下载文档失败:', error)
    ElMessage.error('下载失败')
  }
}

// 删除文档
const deleteDocument = async (document) => {
  try {
    await ElMessageBox.confirm(
      `确定要删除文档"${document.name}"吗？`,
      '警告',
      {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }
    )
    
    const kbId = route.params.id
    await agentAPI.delFileDocument(kbId, document.id)
    
    // 从列表中移除
    const index = documentList.value.findIndex(item => item.id === document.id)
    if (index > -1) {
      documentList.value.splice(index, 1)
    }
    
    ElMessage.success('删除成功')
  } catch (error) {
    if (error !== 'cancel') {
      console.error('删除文档失败:', error)
      ElMessage.error('删除失败')
    }
  }
}

// 添加文档
const addDocument = async () => {
  if (!knowledgeForm.file) {
    ElMessage.error('请选择要上传的文件')
    return
  }
  
  try {
    uploading.value = true
    const kbId = route.params.id
    console.log('kbId', {
      datasetld: kbId,
      content: knowledgeForm.content,
    })
    // 创建 FormData
    // const formData = new FormData()
    // formData.append('file', knowledgeForm.file)
    // formData.append('data', new Blob([JSON.stringify({
    //   datasetld: kbId,
    //   content: knowledgeForm.content||"默认内容",
    // })], { type: "application/json" }))

    const data = {
      datasetId: kbId,
      content: knowledgeForm.content||"知识库修改",
      type: 0
    }
    
    await approvalAPI.submitApproval(knowledgeForm.file,data)
    
    if(isAdmin.value){
    ElMessage.success('添加文档成功')
    }else{
      ElMessage.success('添加文档成功，等待管理员审核')
    }
    
    
    knowledgeDialogVisible.value = false
    // 重新获取列表
    await fetchKnowledgeBaseDetail()
  } catch (error) {
    console.error('添加文档失败:', error)
    ElMessage.error('添加文档失败')
  } finally {
    uploading.value = false
  }
}

// 修改保存知识函数
const saveKnowledge = async () => {
  if (!knowledgeForm.title) {
    ElMessage.error('请填写文档名称')
    return
  }
  
  if (!knowledgeForm.file) {
    ElMessage.error('请选择要上传的文件')
    return
  }
  
  try {
    if (isEdit.value) {
      // 编辑逻辑
      ElMessage.success('编辑成功')
    } else {
      // 添加文档逻辑
      await addDocument()
    }
    
    knowledgeDialogVisible.value = false
  } catch (error) {
    console.error('保存失败:', error)
    ElMessage.error('保存失败')
  }
}

// 重置表单
const resetForm = () => {
  Object.assign(knowledgeForm, {
    title: '',
    content: '',
    file: null
  })
  if (uploadRef.value) {
    uploadRef.value.clearFiles()
  }
}

// 修改添加知识函数
const addKnowledge = () => {
  isEdit.value = false
  resetForm()
  knowledgeDialogVisible.value = true
}

// 修改文档菜单功能
const showDocumentMenu = (document) => {
  // 创建下拉菜单
  const menuItems = [
    {
      label: '编辑',
      icon: 'Edit',
      action: () => editDocument(document)
    },
    {
      label: '预览',
      icon: 'View',
      action: () => previewDocument(document)
    },
    {
      label: '删除',
      icon: 'Delete',
      action: () => deleteDocument(document),
      type: 'danger'
    }
  ]
  
  // 这里可以使用 Element Plus 的 Dropdown 组件
  // 或者显示一个自定义的菜单
  ElMessage.info(`显示菜单: ${document.name}`)
}

// 编辑文档
const editDocument = (document) => {
  isEdit.value = true
  Object.assign(knowledgeForm, {
    title: document.name,
    category: document.fileType,
    content: `文件类型: ${document.fileType}, 大小: ${document.fileSize}, 字数: ${document.wordCount}`,
    tags: ''
  })
  knowledgeDialogVisible.value = true
}

// 预览文档
const previewDocument = (document) => {
  ElMessage.info(`预览文档: ${document.name}`)
  // 这里可以实现文档预览功能
}

// 在onMounted中调用
onMounted(() => {
  fetchKnowledgeBaseDetail()
})

// 分页处理
const handleSizeChange = (val) => {
  pageSize.value = val
  fetchKnowledgeBaseDetail()
}

const handleCurrentChange = (val) => {
  currentPage.value = val
  fetchKnowledgeBaseDetail()
}

const goBack = () => {
  router.push({ name: 'KnowledgeBase' })
}
</script>

<style scoped>
.knowledge-detail-page {
  padding: 20px;
}

.breadcrumb {
  margin-bottom: 20px;
}

.page-header {
  margin-bottom: 30px;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.title-section h1 {
  font-size: 28px;
  color: #1e293b;
  margin: 0 0 10px 0;
}

.title-section p {
  color: #64748b;
  margin: 0;
}

.action-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.search-section {
  display: flex;
  gap: 16px;
  align-items: center;
}

.document-list {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.document-name {
  display: flex;
  align-items: center;
  gap: 8px;
}

.file-icon {
  font-size: 16px;
}

.pdf-icon {
  color: #dc2626;
}

.word-icon {
  color: #2563eb;
}

.excel-icon {
  color: #16a34a;
}

.ppt-icon {
  color: #ea580c;
}

.default-icon {
  color: #6b7280;
}

.segmentation-mode {
  display: flex;
  align-items: center;
  gap: 4px;
}

.gear-icon {
  font-size: 12px;
  color: #6b7280;
}

.status-indicator {
  display: flex;
  align-items: center;
  gap: 6px;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #d1d5db;
}

.status-dot.available {
  background-color: #10b981;
}

.action-btn {
  margin-left: 8px;
}

.delete-btn {
  color: #f56c6c;
}

.delete-btn:hover {
  color: #f56c6c;
  background-color: #fef2f2;
}

.pagination-wrapper {
  padding: 20px;
  display: flex;
  justify-content: center;
}

@media (max-width: 768px) {
  .action-bar {
    flex-direction: column;
    gap: 16px;
    align-items: stretch;
  }
  
  .search-section {
    flex-direction: column;
  }
  
  .header-content {
    flex-direction: column;
    gap: 16px;
  }
}
</style> 